module.exports = __webpack_public_path__ + "static/media/footer.5a843117.jpg";